module.exports = __webpack_public_path__ + "img/managed-cloud.b3402082.webp";